import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        rules: [],
        agents: [],
        instructors: [],
        customers: [],
        jumps: [],
        totals: [],
        canceled: [],
        addons: [],
        merch: [],
        pilots: [],
        plains: [],
        checkedin: [],
        flights: [],
        results: [],
        products: [],
        bill: [],
        uuid: null,
        owc: { wc1: 35, wc2: 1.5 },

        range: [],
        detail: [],
        pilots_detail: [],

        m_lOpts: [null, "Men", "Ladies", "Unisex"],
        colours: [
            null,
            "Black",
            "White",
            "Blue",
            "Turquoise",
            "Gray",
            "Light Blue"
        ],
        sizes: [
            null,
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "XXL",
            "XXXL",
            "XXXXL",
            "Uni Size"
        ],

        merch_filters: {
            m_l: [],
            colour: [],
            size: []
        },

        basket: [],
        flightsTotals: [],

        resources: [],
        plain_logs: [],
        dailysales: [],

        isToday: true,
        currentDate: "",
        currentDateObj: null,

        salesreport: [],
        logsbyplainrange: [],
        components: [],
        componentTypes: [],
        rigs: [],

        totalsbysource: [],

        components_logs: [],

        dailypacks: [],
        packers: [],
        totalsbypacker: [],

        detailbypacker: [],
        packingjobs: [],
        resources_logs: [],
        transactions: [],
        users: [],
        roles: [],
        user: {},
        tasks: [],
        wages: [],
        wagesbyrange: [],
        wages_reports: [],
        wages_reports_index: [],
        staff_tips:[],
        detail_wagesbyrange :[],
        recentJumps: []
    },

    mutations: {
        SET_DETAIL_WAGES (state, wages) {
            state.detail_wagesbyrange = wages
        },
        SET_STAFF_TIPS(state, staff_tips) {
            state.staff_tips = staff_tips
        },

        SET_WAGESREPORTS_INDEX(state, wages) {
            state.wages_reports = wages;
        },
        SET_WAGESREPORTS(state, wages) {
            state.wages_reports = wages;
        },

        SET_WAGESRANGE(state, wages) {
            state.wagesbyrange = wages;
        },

        SET_WAGESBYDAY(state, wages) {
            state.wages = wages;
        },

        SET_TASKS(state, tasks) {
            state.tasks = tasks;
        },

        SET_ROLES(state, roles) {
            state.roles = roles;
        },

        SET_USERS(state, users) {
            state.users = users;
        },

        SET_PACKERS(state, packers) {
            state.packers = packers;
        },

        SET_LOGSBYPLAIN(state, logs) {
            state.logsbyplainrange = logs;
        },

        SET_CURRENTDATE(state, currentDateStr) {
            state.currentDate = currentDateStr;

            const currentDateObj = new Date(currentDateStr + "T00:00:00");
            state.isToday = currentDateObj.isToday() ? true : false;

            state.currentDateObj = currentDateObj;
        },

        SET_PLAINLOGS(state, logs) {
            state.plain_logs = logs;
        },

        SET_COMPLOGS(state, logs) {
            state.components_logs = logs;
        },

        SET_RESLOGS(state, logs) {
            state.resources_logs = logs;
        },

        SET_BASKET(state, items) {
            state.merch_filters = filters;
        },

        SET_MERCHFILTERS(state, filters) {
            state.merch_filters = filters;
        },

        SET_RANGE(state, range) {
            state.range = range;
        },

        SET_PRODUCTS(state, products) {
            state.products = products;
        },

        SET_AGENTS(state, agents) {
            state.agents = agents;
        },
        SET_INTRUCTORS(state, instructors) {
            state.instructors = instructors;
        },

        SET_CUSTOMERS(state, customers) {
            state.customers = customers;
        },

        SET_JUMPS(state, jumps) {
            state.jumps = jumps;
        },

        SET_TOTALS(state, totals) {
            state.totals = totals;
        },

        SET_TOTAL_LOADS(state, totals) {
            state.flightsTotals = totals;
        },

        SET_TOTALSBYSOURCE(state, totalsbysource) {
            state.totalsbysource = totalsbysource;
        },

        SET_TOTALSBYPACKER(state, totalsbypacker) {
            state.totalsbypacker = totalsbypacker;
        },

        SET_DETAILBYPACKER(state, detailbypacker) {
            state.detailbypacker = detailbypacker;
        },

        SET_DETAIL(state, detail) {
            state.detail = detail;
        },

        SET_PILOTS_DETAIL(state, detail) {
            state.pilots_detail = detail;
        },

        SET_CANCELED(state, canceled) {
            state.canceled = canceled;
        },

        SET_ADDONS(state, addons) {
            state.addons = addons;
        },

        SET_MERCH(state, merch) {
            state.merch = merch;
        },

        SET_PILOT(state, pilots) {
            state.pilots = pilots;
        },

        SET_PLAIN(state, plains) {
            state.plains = plains;
        },

        SET_CHECKEDIN(state, checkedin) {
            state.checkedin = checkedin;
        },

        SET_RECENTJUMPS(state, recentJumps) {
            state.recentJumps = recentJumps;
        },

        SET_FLIGHTS(state, flights) {
            state.flights = flights;
        },

        SET_RESULTS(state, results) {
            state.results = results;
        },

        SET_BILL(state, bill) {
            state.bill = bill;
        },

        SET_RESOURCE(state, resources) {
            state.resources = resources;
        },

        SET_DAILYREPORT(state, meta) {
            state.dailysales = meta;
        },

        SET_DAILYPACKS(state, packs) {
            state.dailypacks = packs;
        },

        SET_SALESREPORT(state, meta) {
            state.salesreport = meta;
        },

        SET_COMPONENTS(state, components) {
            state.components = components;
        },

        SET_COMPONENT_TYPES(state, componentTypes) {
            state.componentTypes = componentTypes;
        },

        SET_RIGS(state, rigs) {
            state.rigs = rigs;
        },

        SET_PACKINGJOBSREPORT(state, packingjobs) {
            state.packingjobs = packingjobs
        },

        SET_transactions(state, transactions) {

            state.transactions = transactions
        },

        updateAbilities(state, abilities) {
            // console.log(abilities)
            state.rules = abilities;
        }
    },

    actions: {
        async getAbilities({ commit }) {
            await axios.get("/api/abilities").then(response => {
                commit("updateAbilities", response.data);
            });
        },

        async fetchSalesReportbyRange({ commit }, filter) {
            let params = {
                filter
            };

            const rsales = await axios.get(`/api/sales/`, { params });
            const salesbyrange = rsales.data;

            commit("SET_SALESREPORT", salesbyrange);
        },

        async fetchWagesbyRange({ commit }, filter) {
            let params = {
                filter
            };

            const rsales = await axios.get(`/api/wages`, { params });
            const wagesbyrange = rsales.data;

            commit("SET_WAGESRANGE", wagesbyrange);
        },

        async fetchWagesReportsbyRange({ commit }, range) {
            let params = {
                range
            };

            const rsales = await axios.get(`/api/wages_reports`, { params });
            const wagesbyrange = rsales.data;

            commit("SET_WAGESREPORTS", wagesbyrange);
        },

        async fetchWagesReportsIndex({ commit }) {
            const reports = await axios.get(`/api/wages_reports`);
            const wagesbyrange = reports.data;

            commit("SET_WAGESREPORTS_INDEX", wagesbyrange);
        },

        async fetchStaffTips({ commit }, range) {

            let params = {
                range
            }

            const reports = await axios.get(`/api/wages_reports/staffTipsTransactions/`, { params });
            const staff_tips = reports.data;

            commit("SET_STAFF_TIPS", staff_tips);
        },

        async fetchWagesReportbyDate({ commit }, filter) {
            let params = {
                filter
            };

            const rwages = await axios.get(`/api/wages/` + params.filter);
            const dailywages = rwages.data;

            commit("SET_WAGESBYDAY", dailywages);
        },

        async fetchSalesReportbyDate({ commit }, filter) {
            let params = {
                filter
            };

            const rsales = await axios.get(`/api/sales/` + params.filter);
            const dailysales = rsales.data;

            commit("SET_DAILYREPORT", dailysales);
        },


        async fetchTransactions({ commit }, filter) {
            let params = {
                filter
            };

            const rsales = await axios.get(`/api/sales/transactions`, {
                params
            });
            const transactions = rsales.data;

            commit("SET_transactions", transactions);
        },

        async fetchPacksReportbyDate({ commit }, filter) {
            let params = {
                filter
            };

            const rpacks = await axios.get(
                `/api/packing_jobs/` + params.filter
            );
            const dailypacks = rpacks.data;

            commit("SET_DAILYPACKS", dailypacks);
        },

        async fetchPlainReportbyDate({ commit }, filter) {
            let params = {
                filter
            };

            const rflights = await axios.get(
                `/api/aircraft_logs/byDate/` + params.filter
            );
            const flights = rflights.data;
            commit("SET_PLAINLOGS", flights);

            const rResource = await axios.get(`/api/resources`);
            const resources = rResource.data;
            commit("SET_RESOURCE", resources);
        },

        async fetchProducts({ commit }) {
            const response = await axios.get(`/api/products`);
            const products = response.data;
            commit("SET_PRODUCTS", products);
        },

        async fetchAgents({ commit }) {
            const response = await axios.get(`/api/agents`);
            const agents = response.data;
            commit("SET_AGENTS", agents);
        },

        async fetchData({ commit }) {
            // const response = await axios.get(`/api/agents`)
            // const agents = response.data
            // commit('SET_AGENTS', agents)

            const rCustomers = await axios.get(`/api/customers`);
            const customers = rCustomers.data;
            commit("SET_CUSTOMERS", customers);

            // const rJumps = await axios.get(`/api/jumps/booked`)
            // const jumps = rJumps.data
            // commit('SET_JUMPS', jumps)
        },

        async fetchCustomersWithAddons({ commit }) {
            const rCustomers = await axios.get(`/api/customers/withaddons`);
            const customers = rCustomers.data;
            commit("SET_CUSTOMERS", customers);
        },

        async fetchAllMerch({ commit }) {
            const rMerch = await axios.get(`/api/merch/all`);
            const merch = rMerch.data;
            commit("SET_MERCH", merch);
        },

        async fetchInstructors({ commit }) {
            const respInstructors = await axios.get(`/api/instructors`);
            const instructors = respInstructors.data;
            commit("SET_INTRUCTORS", instructors);
        },

        async fetchPackers({ commit }) {
            const respPackers = await axios.get(`/api/packers`);
            const packers = respPackers.data;
            commit("SET_PACKERS", packers);
        },

        async fetchAddons({ commit }) {
            const rAddons = await axios.get(`/api/merch/addons`);
            const addons = rAddons.data;
            commit("SET_ADDONS", addons);
        },

        async fetchMerch({ commit }) {
            const rMerch = await axios.get(`/api/merch/merch`);
            const merch = rMerch.data;
            commit("SET_MERCH", merch);
        },

        async fetchManifestData({ commit }) {
            const rPilot = await axios.get(`/api/pilots`);
            const pilots = rPilot.data;
            commit("SET_PILOT", pilots);

            const rPlain = await axios.get(`/api/plains`);
            const plains = rPlain.data;
            commit("SET_PLAIN", plains);
        },

        async fetchPlains({ commit }) {
            const rPlain = await axios.get(`/api/plains`);
            const plains = rPlain.data;
            commit("SET_PLAIN", plains);
        },

        async fetchPilots({ commit }) {
            const rPilot = await axios.get(`/api/pilots`);
            const pilots = rPilot.data;
            commit("SET_PILOT", pilots);
        },

        async reloadManifest({ commit }) {
            //So it can just keep working the way it is

            const rflights = await axios.get(`/api/flights/today`);
            const flights = rflights.data;
            commit("SET_FLIGHTS", flights);

            const rcheckedIn = await axios.get(`/api/jumps/checked-in`);
            const checkedin = rcheckedIn.data;
            commit("SET_CHECKEDIN", checkedin);
        },

        async reloadCheckedIn({ commit }) {
            const rcheckedIn = await axios.get(`/api/jumps/checked-in`);
            const checkedin = rcheckedIn.data;
            commit("SET_CHECKEDIN", checkedin);
        },

        async getRecentlyAddedJumps({ commit }) {
            const recentJumps = await axios.get(`/api/jumps/recent`);
            const recent = recentJumps.data;
            commit("SET_RECENTJUMPS", recent);
        },

        async getFlightsbyDate({ commit }, filter) {
            let params = {
                filter
            };

            const rflights = await axios.get(`/api/flights/` + params.filter);
            const flights = rflights.data;
            commit("SET_FLIGHTS", flights);
        },

        async fetchCustomerMerch({ commit }, filter) {
            let params = {
                filter
            };

            const rMerch = await axios.get(
                `/api/customers/getmerch/` + params.filter
            );
            const bill = rMerch.data;
            commit("SET_BILL", bill);
        },

        async fetchJumpsbyRange({ commit }, filter) {
            let params = {
                filter
            };

            const rTotals = await axios.get(`/api/jumps/totals`, { params });
            const totals = rTotals.data;
            commit("SET_TOTALS", totals);
        },

        async fetchPackingJobsbyPacker({ commit }, filter) {
            let params = {
                filter
            };

            const rTotals = await axios.get(
                `/api/packing_jobs/totalsbypacker`,
                { params }
            );
            const totalsbypacker = rTotals.data;
            commit("SET_TOTALSBYPACKER", totalsbypacker);
        },

        async fetchDetailJobsbyPacker({ commit }, filter) {
            let params = {
                filter
            };

            const rTotals = await axios.get(
                `/api/packing_jobs/detailbypacker`,
                { params }
            );
            const detailbypacker = rTotals.data;
            commit("SET_DETAILBYPACKER", detailbypacker);
        },

        async fetchPackingJobsReport({ commit }, filter) {
            let params = {
                filter
            };

            const rTotals = await axios.get(`/api/packing_jobs`, { params });
            const packingjobs = rTotals.data;
            commit("SET_PACKINGJOBSREPORT", packingjobs);
        },

        async fetchPckgbySource({ commit }, filter) {
            let params = {
                filter
            };

            const rTotals = await axios.get(`/api/jumps/totalsbysource`, {
                params
            });
            const totalsbysource = rTotals.data;
            commit("SET_TOTALSBYSOURCE", totalsbysource);
        },

        async fetchLoadsbyRange({ commit }, filter) {
            let params = {
                filter
            };

            const rTotals = await axios.get(`/api/flights/totals`, { params });
            const totals = rTotals.data;
            commit("SET_TOTAL_LOADS", totals);
        },

        async fetchJumpsbyInstructor({ commit }, filter) {
            let params = {
                filter
            };

            const rDetail = await axios.get(`/api/instructors/detail`, {
                params
            });
            const detail = rDetail.data;

            commit("SET_DETAIL", detail);
        },

        async fetchLoadsbyPilot({ commit }, filter) {
            let params = {
                filter
            };

            const rDetail = await axios.get(`/api/pilots/detail`, { params });
            const detail = rDetail.data;

            commit("SET_PILOTS_DETAIL", detail);
        },

        async fetchLogsbyPlain({ commit }, filter) {
            let params = {
                filter
            };

            const rDetail = await axios.get(`/api/aircraft_logs`, { params });
            const logsbyplainrange = rDetail.data;

            logsbyplainrange.forEach(function(el) {
                el.timeXLoad = (el.tach_hrs / el.timeXLoad);
            });

            commit("SET_LOGSBYPLAIN", logsbyplainrange);
        },

        async fetchWagesDetail({ comit }, filter) {

            let params = {
                filter
            };
            
            const wDetail = await axios.get(`/api/wages/detail/`, { params }),
            wages_detail = wDetail.data
            this.commit('SET_DETAIL_WAGES', wages_detail)

        },

        async fetchComponentsLogbyDate({ commit }, filter) {
            let params = {
                filter
            };

            axios
                .get(`/api/component_logs`, { params })
                .then(res => {
                    commit("SET_COMPLOGS", res.data);
                })
                .catch(err => {
                    console.log(err);
                });
        },

        async fetchResourcesLogbyDate({ commit }, filter) {
            let params = {
                filter
            };

            axios
                .get(`/api/resource_logs`, { params })
                .then(res => {
                    commit("SET_RESLOGS", res.data);
                })
                .catch(err => {
                    console.log(err);
                });
        },

        async fetchResults({ commit }, filter) {
            let params = {
                filter
            };

            axios
                .get(`/api/jumps/search`, { params })
                .then(res => {
                    commit("SET_RESULTS", res.data);

                    //console.log('request sent successfully')
                })
                .catch(err => {
                    console.log(err);
                });
        },

        async fetchJumps({ commit }, filter) {
            let params = {
                filter
            };

            axios
                .get(`/api/jumps/all`, { params })
                .then(res => {
                    commit("SET_RESULTS", res.data);

                    //console.log('request sent successfully')
                })
                .catch(err => {
                    console.log(err);
                });
        },

        async fetchResources({ commit }) {
            const rResource = await axios.get(`/api/resources`);
            const resources = rResource.data;
            commit("SET_RESOURCE", resources);
        },

        async fetchComponents({ commit }) {
            const rComponents = await axios.get(`/api/components`);
            const components = rComponents.data;
            commit("SET_COMPONENTS", components);
        },

        async fetchComponentTypes({ commit }) {
            const rComponents = await axios.get(`/api/componentTypes`);
            const componentTypes = rComponents.data;
            commit("SET_COMPONENT_TYPES", componentTypes);
        },

        async fetchRigs({ commit }) {
            const rRigs = await axios.get(`/api/rigs`);
            const rigs = rRigs.data;
            commit("SET_RIGS", rigs);
        },

        async fetchUsers({ commit }) {
            const respUsers = await axios.get(`/api/users`);
            const users = respUsers.data;
            commit("SET_USERS", users);
        },

        async fetchRoles({ commit }) {
            const respRoles = await axios.get(`/api/roles`);
            const roles = respRoles.data;
            commit("SET_ROLES", roles);
        },

        async fetchTasks({ commit }) {
            const respTasks = await axios.get(`/api/tasks`);
            const tasks = respTasks.data;
            commit("SET_TASKS", tasks);
        }
    },

    modules: {},

    getters: {
       

        ability: state => {
            return state.rules;
        },

        emails: state => {
            return state.users.map(function(u) {
                return u.email;
            });
        },

        role_names: state => {
            var roles = state.roles.map(function(r) {
                return r.name;
            });

            roles.shift();
            return roles;
        },

        oil_log: state => {
            return state.resources_logs.filter(function(r) {
                return r.resource_id == 1;
            });
        },

        fuel_log: state => {
            return state.resources_logs.filter(function(r) {
                return r.resource_id == 2;
            });
        },

        logsbyplainrange: state => {
            return state.logsbyplainrange.forEach(function(el) {
                el.timeXLoad = el.timeXLoad / el.completeLoads;
            });
        },

        booked: state => {
            return state.customers.filter(j => {
                return j.status == 1;
            });
        },

        checkedin: state => {
            return state.customers.filter(j => {
                return j.status != 1;
            });
        },

        onlineRigs: state => {
            return state.rigs.filter(r => {
                return r.status == 1;
            });
        },

        filteredMerch: state => {
            let m_lOpts =
                    state.merch_filters.m_l.length == 0
                        ? state.m_lOpts
                        : state.merch_filters.m_l,
                colours =
                    state.merch_filters.colour.length == 0
                        ? state.colours
                        : state.merch_filters.colour,
                sizes =
                    state.merch_filters.size.length == 0
                        ? state.sizes
                        : state.merch_filters.size;

            return state.merch
                .filter(el => {
                    return el.category !== "pckg" && el.category !== "ow";
                })
                .filter(item => {
                    return m_lOpts.includes(item.m_l);
                })
                .filter(item => {
                    return colours.includes(item.colour);
                })
                .filter(item => {
                    return sizes.includes(item.size);
                });
        },

        calculatedDailySales: state => {
            state.dailysales.totalSales;

            return state.dailysales.totalSales;
        },

        dailySalesReport: state => {
            return state.dailysales.salesReport;
        },

        allTransactionsByDate: state => {
            return state.dailysales.allTransactions;
        },

        dailyPacksReport: state => {
            return state.dailypacks.packsReport;
        },

        safe: state => {
            return state.dailysales.safe;
        },

        activePackers: state => {
            let activePackers = state.dailypacks.packers || [],
                user_id = state.user.id;

            if (state.user.roles.includes("packer")) {
                return state.packers.filter(function(r) {
                    return r.user_id == user_id;
                });
            }

            return activePackers;
        },

        activePilots: state => {
            return state.pilots.filter(function(f) {
                return f.status == 1;
            });
        },

        activeInstructors: state => {
            return state.instructors.filter(function(f) {
                return f.status == 1;
            });
        },

        packs: state => {
            return state.dailypacks.packs;
        },

        totalJumps: state => {
            return state.dailysales.totalJumps;
        },

        onHandItems: state => {
            return [
                { ones: 1 },
                { fives: 5 },
                { tens: 10 },
                { twenties: 20 },
                { fifties: 50 },
                { hundreds: 100 }
            ];
        }
    }
});
